module.exports = __webpack_public_path__ + "img/flexible-payment-options@2x.951f6478.jpg";